import en from '@root/bind.joinroot.com/src/services/i18n/locales/en';

export default ({
  en,
});
